module.exports = __webpack_public_path__ + "static/media/94.ae2158eb.jpg";